import { Link, useNavigate } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
// import styles from 'pages/Promotions/styles/promo.module.css';
import { useEffect } from 'react';

interface ModalBackdropErrorProps {
  isError: boolean;
  setIsError: (value: boolean) => void;
  message: string;
  redirect?: string;
  ButtonMsg: string;
  AutoCloseTime?: number;
  icon?: string;
}

const ModalBackdropError = ({
  isError,
  setIsError,
  message,
  redirect = '',
  ButtonMsg,
  AutoCloseTime = 5000,
  icon = '',
}: ModalBackdropErrorProps) => {
  const history = useNavigate();

  const closeModal = () => {
    setIsError(false);
  };

  useEffect(() => {
    if (isError) {
      const timer = setTimeout(() => {
        if (redirect !== '') {
          history(redirect);
        }
        setIsError(false);
      }, AutoCloseTime);

      return () => clearTimeout(timer);
    }
  }, [isError, history, redirect, setIsError, AutoCloseTime]);

  return (
    <Modal
      isOpen={isError}
      toggle={closeModal}
      backdrop={'static'}
      id="staticBackdropError"
      centered
      data-testid="modal-error"
    >
      <ModalHeader className="d-flex align-items-center justify-content-between"></ModalHeader>
      <ModalBody className="text-center p-5">
        <i className={`bx bx-error-circle display-4 text-warning`}></i>

        <div className="mt-4">
          <h4 className="mb-3">{message}</h4>

          <br />

          <div className="hstack gap-2 justify-content-center">
            <Link
              to={redirect === '' ? '#' : redirect}
              // className={`btn ${styles['custom-violet-btn']}`}
              className={`btn btn-primary`}
              onClick={closeModal}
            >
              {ButtonMsg}{' '}
              {icon !== '' ? <i className={`${icon} align-middle`}></i> : null}
            </Link>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalBackdropError;
